<template>
  <div class="angebote--page">

    <loading-data-page-container :loading="loading"
                                 :loading-error="loadingError"
                                 :loading-error-message="loadingErrorMsg">

      <v-container v-if="!loading && !loadingError" class="pa-0" fluid>

        <div class="semanticsection-title2 primary--text">Angebote</div>

        <table-container @excel="exportExcel"
                         @reset-filters="resetSingleFilter">
          <!--- full search ----------------------------------------------------------------------------->
          <v-text-field slot="full-search"
                        v-model="search"
                        label="Nach Angebot suchen"
                        append-icon="search"
                        single-line
                        hide-details
                        clearable />

          <!--- detail filters ----------------------------------------------------------------------------->
          <v-row slot="detail-filters"
                 class="detail--filters"
                 no-gutters>
            <v-col cols="12"
                   sm="6"
                   md="4">
              <date-field v-model="singleFilters.Erstellt.von"
                          v-validate="'date_format:DD.MM.YYYY'"
                          :clear-icon-cb="applySingleFilter"
                          hide-details
                          clearable
                          label="Erstellt von"
                          class="mb0 date--field"
                          @input="applySingleFilter" />
            </v-col>
            <v-col cols="12"
                   sm="6"
                   md="4">
              <date-field v-model="singleFilters.Erstellt.bis"
                          v-validate="'date_format:DD.MM.YYYY'"
                          :clear-icon-cb="applySingleFilter"
                          hide-details
                          clearable
                          label="Erstellt bis"
                          class="date--field"
                          @input="applySingleFilter" />
            </v-col>
            <v-col cols="12"
                   sm="6"
                   md="4">
              <v-text-field v-model="singleFilters.Name"
                            clearable
                            hide-details
                            label="Name"
                            @input="applySingleFilter" />
            </v-col>
            <v-col cols="12"
                   sm="6"
                   md="4">
              <v-text-field v-model="singleFilters.Produkt"
                            clearable
                            hide-details
                            label="Produkt"
                            @input="applySingleFilter" />
            </v-col>
            <v-col cols="12"
                   sm="6"
                   md="4">
              <v-text-field v-model="singleFilters.Versicherungsumfang"
                            clearable
                            hide-details
                            label="Versicherungsumfang"
                            @input="applySingleFilter" />
            </v-col>
            <v-col cols="12"
                   sm="6"
                   md="4">
              <v-select v-model="singleFilters.Art"
                        :items="angebotsArtOptions"
                        hide-details
                        label="Art"
                        @input="applySingleFilter" />
            </v-col>
            <v-col cols="12"
                   sm="6"
                   md="4">
              <v-text-field v-model="singleFilters.Angebotsnummer"
                            clearable
                            hide-details
                            label="Angebotsnummer"
                            @input="applySingleFilter" />
            </v-col>

          </v-row>

          <angebote-table ref="angeboteTable"
                          :angebote="filteredAngebote"
                          :search="search"
                          :superuser="showSuperuserAngebote"
                          @details="details"
                          @info="info"
                          @edit="edit"
                          @remove="confirmRemove" />
        </table-container>
        <div class="dmb-form-text warning--text">{{ loadingErrorMsg }}</div>

      </v-container>

    </loading-data-page-container>

    <!-- confirm dialog for deleting angebot----------------------------------------------------->
    <v-dialog v-model="confirmDialog"
              max-width="270">
      <v-card>
        <v-card-title class="title">Wollen Sie das Angebot löschen?</v-card-title>

        <v-card-text>
          Das Angebot wird unwiderruflich aus dem System gelöscht.
        </v-card-text>

        <v-card-actions>

          <v-btn text
                 @click="confirmDialog = false">Abbrechen
          </v-btn>

          <v-spacer />

          <v-btn color="primary"
                 text
                 @click="remove">Löschen
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- error / success message -->
    <v-snackbar v-model="snackbar"
                :timeout="4000"
                :color="snackbarColor"
                bottom
                multi-line>
        <span class="snackbar-message text-center">
          <v-icon v-if="snackbarColor==='error'"
                  color="white">warning</v-icon>{{ snackbarMessage }}</span>
    </v-snackbar>

  </div>
</template>
<script>
import dummyData from "@/store/dummyData/Angebote";
import httpService from '@/helper/httpService';
import TableContainer from "@/components/kundenverwaltung/TableContainer";
import LoadingDataPageContainer from "@/components/kundenverwaltung/LoadingDataPageContainer";
import AngeboteTable from "@/components/kundenverwaltung/AngeboteTable";
import ExcelMixin from '@/pages/kundenverwaltung/ExcelMixin';
import TableDataMixin from '@/pages/kundenverwaltung/TableDataMixin';
import ParsingMixin from '@/pages/kundenverwaltung/ParsingMixin';
import DateField from "@/components/DateField";
import contentLoadingMixin from "@/components/helper/contentLoadingMixin";

import {ANGEBOTSART_VALUES, PRODUKTE_VALUES} from "@/components/kundenverwaltung/valueLists";
import {CONNECTION_ERROR_MESSAGE} from "@/helper/httpService";

export default {
  components: {
    LoadingDataPageContainer, AngeboteTable, TableContainer, DateField
  },
  mixins: [ExcelMixin, TableDataMixin, ParsingMixin, contentLoadingMixin(["ARB", "PI_Standard", "PI_EXPERT", "PI_PRESTIGE"])],
  data() {
    return {
      loading: true,
      loadingError: false,
      loadingErrorMsg: '',
      confirmDialog: false,
      snackbar: false,
      snackbarColor: 'error',
      snackbarMessage: '',
      idToDelete: '',
      offerToDeleteIsLegacy: false,
      angebote: [],
      formattedAngebote: [],
      filteredAngebote: [],
      search: '',
      singleFilters: this.getInitalFilterState()
    };
  },
  computed: {
    angebotsArtOptions() {
      const options = ANGEBOTSART_VALUES.filter(art => {
        const artBackendFormat = art === 'Vorschlag' ? 'Kurzangebot' : art;
        return this.angebote.find(item => item.art === artBackendFormat);
      });
      options.push({ text: 'alle', value: '' });
      return options;
    },
    showSuperuserAngebote() {
      return this.$store.getters.showSuperuserAngebote;
    }
  },
  created() {
    httpService.getAngebote()
      .then(result => {
        this.loadingErrorMsg = "";
        this.angebote = result.angebote;
        this.formattedAngebote = result.angebote.map(this.formatData);
        this.filteredAngebote = [].concat(this.formattedAngebote);

        result.errors.forEach(error => console.log(`GET OFFERS failed with ${error.status}: ${error.message}`));

        if (result.errors.length === 2) {
          // both (= all) requests failed
          if (this.$store.state.env.environment === 'development') {
            //TODO delete dummy data for production
            this.angebote = dummyData;
            this.formattedAngebote = dummyData.map(this.formatData);
            this.filteredAngebote = [].concat(this.formattedAngebote);
          } else {
            // only first error used for frontend message
            this.loadingErrorMsg = result.errors[0].status < 500 ? 'Keine Angebote gefunden' : CONNECTION_ERROR_MESSAGE;
            this.loadingError = true;
          }
        } else if (result.errors.length > 0) {
          this.loadingErrorMsg = "Angebote konnten nur teilweise geladen werden.";
        }
        this.loading = false;
      });
  },
  methods: {
    formatData: function (angebot) {
      let frontendAngebotsart = angebot.art;
      if (angebot.art === 'Kurzangebot') {
        // Änderung currently only supports Kurzangebot, no need to check otherwise
        if (angebot.artAenderung) {
          frontendAngebotsart = 'Änderung';
        } else {
          frontendAngebotsart = 'Vorschlag';
        }
      }
      let frontEndName = "";
      if (angebot.vn) {
        frontEndName = [angebot.vn.lastname, angebot.vn.firstname].filter(name => !!name).join(', ');
      } else if (angebot.personen) {
        const vn = angebot.personen.find(p => p.key === 'vn1');
        if (vn) frontEndName = vn.name + ' ' + vn.rechtsform;
      }
      if (frontEndName === "") {
        frontEndName = angebot.name;
      }
      const produkt = angebot.vertrag && angebot.vertrag.produktcode ? PRODUKTE_VALUES.find(p => p.code === angebot.vertrag.produktcode)
        : undefined;
      const frontendProdukt = produkt ? produkt.text
        : angebot.leistungsart ? angebot.leistungsart: this.$store.getters.productLineText(angebot.productLine, angebot.selectedTarif);

      const frontendVersicherungsumfang = Array.isArray(angebot.categories) ? this.getUmfangFromCategories(angebot.categories)
        : Array.isArray(angebot.deckungen) ? this.getUmfangFromDeckungen(angebot.deckungen) : "";
      // prepend string length for sort order to sort by length first; works because length is < 10 in all cases
      const sortableVersicherungsumfang = frontendVersicherungsumfang.length + frontendVersicherungsumfang;

      let ret = {
        Art: frontendAngebotsart,
        Name: frontEndName,
        Angebotsnummer: angebot.angebotsnummer,
        Produkt: frontendProdukt,
        Versicherungsumfang: frontendVersicherungsumfang,
        sortableVersicherungsumfang,
        Erstellt: this.$helpers.dateToTime(angebot.erstellt),
        pdfpfad: !angebot.pdfpfad ? "" : angebot.pdfpfad,
        editpath: angebot.editpath,
        legacy: angebot.legacy,
        gewerbe: !this.isPrivate(angebot)
      };
      if (this.showSuperuserAngebote) {
        ret.sbnr = angebot.user ? angebot.user.username : angebot.sbnr;
        ret.vmnr = angebot.selectedIdentity && angebot.selectedIdentity.vmnr ? angebot.selectedIdentity.vmnr : 
        (angebot.user && angebot.user.vmnr) ? angebot.user.vmnr : angebot.vmnr ;
      }
      return ret;
    },
    details: function (angebotsnummer) {
      const angebot = this.angebote.find(angebot => angebot.angebotsnummer === angebotsnummer);
      if (angebot) {
        const url = !angebot.legacy ?  httpService.adjustUrl(angebot.pdfpfad) + ( angebot.pdfpfad.indexOf('?') >= 0 ? '' : '?disposition=inline') :  httpService.adjustLegacyUrl(angebot.pdfpfad);
        window.open(url, '_blank');
      }
      // TODO: error handling angebot not found?
    },
    info: function (info) {
      let url;
      if (info.type === 'ARB') {
        url = this.ARB.items[0].link;
      } else {
        switch (info.data) {
          case 'Standard':
            url = this.PI_Standard.items[0].link;
            break;
          case 'PRESTIGE':
            url = this.PI_PRESTIGE.items[0].link;
            break;
          default:
            url = this.PI_EXPERT.items[0].link;
        }
      }
      if (url) {
        window.open(url, '_blank');
      }
    },
    edit: function (angebotsnummer) {
      const angebot = this.angebote.find(angebot => angebot.angebotsnummer === angebotsnummer);
      if (angebot.artAenderung) {
        this.$store.dispatch('resetAenderungsData');
        this.$router.push({
          name: 'AenderungUmfangPage',
          params: {
            nummer: angebot.angebotsnummer,
            art: 'angebot',
            data: angebot
          }
        });
      } else {
        if (!this.isPrivate(angebot)) {
          switch (angebot.leistungsart) {
            case "AGROMEX":
              this.$router.push({
                name: 'Landwirtschaft',
                params: {
                  frameUrl: httpService.adjustLegacyUrl(angebot.editpath)
                }
              });
              break;
            case "KOMedEX":
              this.$router.push({
                name: 'Aerzte',
                params: {
                  frameUrl: httpService.adjustLegacyUrl(angebot.editpath)
                }
              });
              break;
            default:
              // should be KOMPEX/Gewerbe at this point
              this.$store.dispatch("gewerbeLoadAngebot", angebot).then(() => {
                this.$router.push("gewerbekundenangebot");
              });
          }
        } else {
          this.$store.dispatch("loadAngebot", angebot);
          this.$router.push("privatkunden");
        }
      }
    },
    confirmRemove: function (angebotsnummer) {
      const angebot = this.angebote.find(angebot => angebot.angebotsnummer === angebotsnummer);
      this.offerToDeleteIsLegacy = angebot.legacy || !!(angebot.leistungsart);
      this.idToDelete = this.offerToDeleteIsLegacy ? angebot.angebotsnummer : angebot.id;
      this.confirmDialog = true;
    },
    remove: function () {
      this.confirmDialog = false;
      Promise.resolve()
        .then(() => {
          return this.offerToDeleteIsLegacy ?
            httpService.deleteLegacyAngebot(this.idToDelete) :
            httpService.deleteAngebot(this.idToDelete);
        })
        .then(() => {
            this.showSnackbar('Das Angebot wurde gelöscht.', 'primary');
            // TODO: instead reload all Angebote from backend?
            this.angebote = this.angebote.filter(angebot =>
              this.offerToDeleteIsLegacy ?
                angebot.angebotsnummer !== this.idToDelete :
                angebot.id !== this.idToDelete);
            this.formattedAngebote = this.angebote.map(this.formatData);
            this.applySingleFilter();
          })
        .catch(() => {
          this.showSnackbar('Das Angebot konnte nicht gelöscht werden.', 'error');
        });
    },
    exportExcel: function () {
      this.generateExcel([].concat(this.angebote.map(this.showSuperuserAngebote ?
        this.formatSuperuserAngeboteDataForExcel :
        this.formatAngeboteDataForExcel)),
        this.showSuperuserAngebote ?
        this.columnFormatSuperuserAngeboteDataForExcel() :
        this.columnFormatAngeboteDataForExcel(),        
         "Angebote");
    },
    showSnackbar: function (msg, color) {
      this.snackbarColor = color;
      this.snackbarMessage = msg;
      this.snackbar = true;
    },
    getInitalFilterState() {
      return {
        Angebotsnummer: '',
        Name: '',
        Produkt: '',
        Versicherungsumfang: '',
        Erstellt: {
          von: '',
          bis: ''
        },
        Art: ''
      };
    },
    applySingleFilter() {
      this.filteredAngebote = this.formattedAngebote.filter(row => {
        if ((this.singleFilters.Erstellt.von || this.singleFilters.Erstellt.bis)
          && !this.filterDateBetween(row.Erstellt, this.singleFilters.Erstellt.von, this.singleFilters.Erstellt.bis)) {
          return false;
        }
        //apply standard filter for remaining header line filters
        const vals = ['Art', 'Angebotsnummer', 'Name', 'Produkt', 'Versicherungsumfang'];
        for (let i = 0; i < vals.length; i++) {
          const columnName = vals[i];
          if (this.singleFilters[columnName] && !this.filterDefault(row[columnName], this.singleFilters[columnName])) {
            return false;
          }
        }
        return true;
      });
    },
    resetSingleFilter() {
      this.singleFilters = this.getInitalFilterState();
      this.applySingleFilter();
    },
    isPrivate(angebot) {
      return angebot.legacy ?  angebot.leistungsart === "Privat" :
        ( (!angebot.vertrag || !angebot.vertrag.produktcode) && !angebot.leistungsart );
    }
  }
};
</script>
<style>
.angebote--page .v-input:not(.v-input--selection-controls) {
  max-width: 344px;
}

.angebote--page .detail--filters div.flex {
  display: flex;
  justify-content: center;
  padding: 0 20px;
}
</style>
